/* MXDVS menu drawer: white terminal (installed 2026-10-03, updated 2026-10-04). Phones and tablets only.
   1. A tap outside the drawer closes it (not only the X).
   2. While a sub menu is open, a tap anywhere outside it only closes that sub menu
      (the blurred links, Shipping & Returns, FAQ, Track order and LOG IN / country included).
   3. While the country list is open, the menu behind it blurs (class mxm-cty).
   4. (Index V2.1) The open country list moves into the menu sheet (class mxm-cl), so it scrolls on
      behind the LOG IN / country row. assets/mxdvs-header.js first moves the open list to the end of
      the page and puts it back in its own place when it closes; this only moves it from the end of
      the page into the sheet. If the rows have not shown 0.7 s after opening, they are shown anyway.
   5. Closing the menu also closes an open country list.
   6. The countries blur as they slide under the LOG IN / country row (up to --mxm-row-blur),
      so the row needs no blur layer of its own.
   7. Custom scrollbar for the country list: a thin line with a thumb (drag it, or tap the line to
      page), shown while scrolling and faded out after --mxm-sb-hide.
   8. (12.10.2026) Drag bar at the top of the sheet instead of the X: drag it down (assets/mxdvs-window-motion.js)
      or tap it to close. The X stays hidden in the page, so every close script keeps working.
   9. (12.10.2026) Country search inside the sheet: the theme's search (assets/localization-form.js) only looks
      inside its own box, and the list now lives in the menu sheet, so it found nothing. Typing filters the list
      here (country name or code, e.g. BE), Enter picks the first country, the reset X clears it, and a line says
      when nothing matches.
  10. (12.10.2026) Long country names on the LOG IN row (e.g. Caribbean Netherlands) stay on one line: the button
      text is split into the name (shortens with ...) and the currency (always shown); see mxdvs-menu-sheet.css. */
(function () {
  if (window.__mxdvsMenuTerminal) return;
  window.__mxdvsMenuTerminal = true;

  var mq = window.matchMedia('(max-width: 989px)');
  var LIST_ID = 'HeaderCountryMobile-country-results';
  var revealTimer = null;
  var blurred = [];
  var blurFrame = 0;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 6. Blur each country by how far it sits under the LOG IN / country row */
  function blurUnderRow() {
    blurFrame = 0;
    var d = drawer(), list = document.getElementById(LIST_ID);
    var panel = countryPanel();
    for (var b = 0; b < blurred.length; b++) blurred[b].style.filter = '';
    blurred = [];
    if (!d || !list || !panel || !panel.classList.contains('mxm-cl')) return;
    var row = d.querySelector('.menu-drawer__utility-links');
    if (!row) return;
    var max = parseFloat(getComputedStyle(d).getPropertyValue('--mxm-row-blur')) || 0;
    if (max <= 0) return;
    var rowTop = row.getBoundingClientRect().top;
    var listRect = list.getBoundingClientRect();
    var items = list.querySelectorAll('.disclosure__item');
    for (var i = 0; i < items.length; i++) {
      /* 2026-10-12: measured on screen (offsetTop counted from the panel, so the blur sat one search bar too high) */
      var r = items[i].getBoundingClientRect();
      if (!r.height) continue;
      var top = r.top;
      var h = r.height;
      if (top + h <= rowTop || top >= listRect.bottom) continue;
      var t = Math.max(0, Math.min(1, (top + h - rowTop) / h));
      items[i].style.filter = 'blur(' + (t * max).toFixed(2) + 'px)';
      blurred.push(items[i]);
    }
  }

  function scheduleBlur() {
    if (!blurFrame) blurFrame = requestAnimationFrame(blurUnderRow);
    scheduleSb();
  }

  /* 7. Custom scrollbar: a thin line with a thumb next to the list (see .mxm-sb in the CSS) */
  var sbFrame = 0;
  var sbTimer = 0;
  var sbDrag = null;

  function sbVar(name, fallback) {
    var d = drawer();
    var v = d ? parseFloat(getComputedStyle(d).getPropertyValue(name)) : NaN;
    return isNaN(v) ? fallback : v;
  }

  function sbElement(panel) {
    var el = panel.querySelector(':scope > .mxm-sb');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'mxm-sb';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="mxm-sb__thumb"></span>';
    panel.appendChild(el);
    el.addEventListener('pointerdown', function (event) {
      var list = document.getElementById(LIST_ID);
      var m = el._m;
      if (!list || !m) return;
      var tr = el.firstChild.getBoundingClientRect();
      event.preventDefault();
      if (event.clientY >= tr.top - 8.5 && event.clientY <= tr.bottom + 8.5) {
        sbDrag = { y: event.clientY, s: list.scrollTop };
        try { el.setPointerCapture(event.pointerId); } catch (e) {}
      } else {
        list.scrollBy({ top: (event.clientY < tr.top ? -1 : 1) * list.clientHeight * 0.8, behavior: 'smooth' });
      }
      wakeSb();
    });
    el.addEventListener('pointermove', function (event) {
      var list = document.getElementById(LIST_ID);
      var m = el._m;
      if (!sbDrag || !list || !m || m.track <= m.thumb) return;
      list.scrollTop = sbDrag.s + (event.clientY - sbDrag.y) * m.range / (m.track - m.thumb);
      wakeSb();
    });
    function endDrag() { if (sbDrag) { sbDrag = null; wakeSb(); } }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    return el;
  }

  function updateSb() {
    sbFrame = 0;
    var panel = countryPanel(), list = document.getElementById(LIST_ID), d = drawer();
    if (!panel || !list || !d || !panel.classList.contains('mxm-cl')) return;
    var el = sbElement(panel);
    var row = d.querySelector('.menu-drawer__utility-links');
    var top = list.offsetTop + 8.5;
    var bottom = (row ? row.getBoundingClientRect().top - panel.getBoundingClientRect().top : panel.clientHeight - 70) - 8.5;
    var track = bottom - top;
    var range = list.scrollHeight - list.clientHeight;
    if (track < 35 || range <= 1) { el.classList.remove('is-scrollable'); return; }
    el.classList.add('is-scrollable');
    var thumb = Math.min(track, Math.max(sbVar('--mxm-sb-min', 35), track * list.clientHeight / list.scrollHeight));
    var y = (track - thumb) * Math.min(1, Math.max(0, list.scrollTop / range));
    el.style.top = top + 'px';
    el.style.height = track + 'px';
    el.firstChild.style.height = thumb + 'px';
    el.firstChild.style.transform = 'translateY(' + y.toFixed(1) + 'px)';
    el._m = { track: track, thumb: thumb, range: range };
    if (sbVar('--mxm-sb-hide', 1200) <= 0) el.classList.add('is-on');
  }

  function scheduleSb() {
    if (!sbFrame) sbFrame = requestAnimationFrame(updateSb);
  }

  /* Show the bar, and fade it out again after --mxm-sb-hide (0 = always shown) */
  function wakeSb() {
    var panel = countryPanel();
    var el = panel && panel.querySelector(':scope > .mxm-sb');
    if (!el) return;
    el.classList.add('is-on');
    clearTimeout(sbTimer);
    var hide = sbVar('--mxm-sb-hide', 1200);
    if (hide > 0) sbTimer = setTimeout(function () { if (!sbDrag) el.classList.remove('is-on'); }, hide);
  }

  function container() { return document.getElementById('Details-menu-drawer-container'); }
  function drawer() { return document.getElementById('menu-drawer'); }
  function countryPanel() {
    var list = document.getElementById(LIST_ID);
    return list ? list.closest('.country-selector') : null;
  }

  function closeDrawer(event) {
    var c = container();
    if (!c || !c.hasAttribute('open')) return;
    var summary = c.querySelector(':scope > summary');
    var headerDrawer = c.closest('header-drawer');
    if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function') headerDrawer.closeMenuDrawer(event, summary);
    else if (summary) summary.click();
  }

  /* Runs on window in the capture phase, so before the accordion's document listener */
  window.addEventListener('click', function (event) {
    if (!mq.matches) return;
    var c = container(), d = drawer();
    if (!c || !d || !c.hasAttribute('open')) return;
    var target = event.target;
    var summary = c.querySelector(':scope > summary');

    /* 1. Outside the drawer (and not the menu icon): close the drawer */
    if (!d.contains(target) && !(summary && summary.contains(target))) {
      if (target.closest && target.closest('.country-selector')) return;
      event.preventDefault();
      event.stopPropagation();
      closeDrawer(event);
      return;
    }

    /* 2. A sub menu is open: a tap outside it only closes it */
    var open = d.querySelector('.menu-drawer__navigation > .menu-drawer__menu > li > details.is-expanded');
    if (!open || open.contains(target)) return;
    if (target.closest('.menu-drawer__close-x') || target.closest('.mxm-handle') || target.closest('.country-selector')) return;
    event.preventDefault();
    event.stopPropagation();
    var openSummary = open.querySelector(':scope > summary');
    if (openSummary) openSummary.click();
  }, true);

  /* 4. The open country list goes into the menu sheet */
  function placeList() {
    var d = drawer(), panel = countryPanel();
    if (!d || !panel) return;
    var inner = d.querySelector('.menu-drawer__inner-container');
    var isOpen = !panel.hasAttribute('hidden');
    if (!isOpen || !inner || !mq.matches) {
      panel.classList.remove('mxm-cl');
      clearTimeout(revealTimer);
      blurUnderRow();
      return;
    }
    var row = d.querySelector('.menu-drawer__utility-links');
    if (row) d.style.setProperty('--mxm-row-h', row.offsetHeight + 'px');
    if (panel.parentNode !== inner) inner.appendChild(panel);
    panel.classList.add('mxm-cl');
    var list = document.getElementById(LIST_ID);
    if (list && !list.dataset.mxmBlur) {
      list.dataset.mxmBlur = '1';
      list.addEventListener('scroll', scheduleBlur, { passive: true });
      list.addEventListener('scroll', wakeSb, { passive: true });
    }
    scheduleBlur();
    setTimeout(function () { scheduleSb(); wakeSb(); }, 120);
    clearTimeout(revealTimer);
    revealTimer = setTimeout(function () {
      if (panel.hasAttribute('hidden')) return;
      if (panel.querySelector('.disclosure__item.is-visible')) return;
      var items = panel.querySelectorAll('.disclosure__item');
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-visible');
    }, 700);
    /* the country filter changes which rows sit under the row */
    var input = panel.querySelector('.country-filter__input');
    if (input && !input.dataset.mxmBlur) {
      input.dataset.mxmBlur = '1';
      input.addEventListener('input', function () { setTimeout(scheduleBlur, 0); setTimeout(scheduleBlur, 350); });
    }
  }

  /* mxdvs-header.js moves the list on its own timing (right away and 50 ms after a tap), so check a few times */
  function schedulePlace() {
    placeList();
    setTimeout(placeList, 0);
    setTimeout(placeList, 80);
    setTimeout(placeList, 200);
  }

  /* 3. Blur the menu while the country list is open, and 4. place the list */
  function watchCountry() {
    var d = drawer();
    if (!d) return;
    var buttons = d.querySelectorAll('.menu-drawer__localization .disclosure__button');
    if (!buttons.length) return;
    function sync() {
      var open = false;
      for (var i = 0; i < buttons.length; i++) if (buttons[i].getAttribute('aria-expanded') === 'true') open = true;
      d.classList.toggle('mxm-cty', open);
      schedulePlace();
    }
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].dataset.mxmWatch) continue;
      buttons[i].dataset.mxmWatch = '1';
      new MutationObserver(sync).observe(buttons[i], { attributes: true, attributeFilter: ['aria-expanded'] });
    }
    var panel = countryPanel();
    if (panel && !panel.dataset.mxmWatch) {
      panel.dataset.mxmWatch = '1';
      new MutationObserver(schedulePlace).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    }
    sync();
  }

  /* 5. Closing the menu also closes an open country list */
  function watchDrawer() {
    var c = container();
    if (!c || c.dataset.mxmWatch) return;
    c.dataset.mxmWatch = '1';
    new MutationObserver(function () {
      if (c.classList.contains('menu-opening')) return;
      var panel = countryPanel();
      if (!panel || panel.hasAttribute('hidden')) return;
      var x = panel.querySelector('.country-selector__close-button');
      if (x) x.click();
    }).observe(c, { attributes: true, attributeFilter: ['class'] });
  }

  /* 8. Drag bar: tapping it closes the menu through the (hidden) X, like before */
  function addHandle() {
    var d = drawer();
    if (!d || d.querySelector(':scope > .mxm-handle')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mxm-handle';
    b.setAttribute('aria-label', 'Close menu');
    b.addEventListener('click', function (event) {
      var x = d.querySelector('.menu-drawer__close-x');
      if (x) x.click();
      else closeDrawer(event);
    });
    d.appendChild(b);
  }

  /* 9. Country search inside the menu sheet */
  function emptyLine(panel) {
    if (!panel.querySelector('#' + LIST_ID)) return null;
    var p = panel.querySelector(':scope > .mxm-cl-empty');
    if (p) return p;
    p = document.createElement('p');
    p.className = 'mxm-cl-empty';
    p.setAttribute('aria-hidden', 'true');
    p.textContent = 'No country matches that. Try a code like BE or NL.';
    var filter = panel.querySelector('.country-filter');
    if (filter && filter.nextSibling) panel.insertBefore(p, filter.nextSibling);
    else panel.appendChild(p);
    return p;
  }

  function filterList(panel, query) {
    var q = String(query || '').trim().toLowerCase();
    var shown = 0;
    panel.querySelectorAll('.countries .disclosure__item').forEach(function (li) {
      var a = li.querySelector('a');
      if (!a) return;
      var c = a.querySelector('.country');
      var text = ((c ? c.textContent : a.textContent) + ' ' + (a.dataset.value || '')).toLowerCase();
      var hit = !q || text.indexOf(q) !== -1;
      li.classList.toggle('hidden', !hit);
      if (hit) shown++;
    });
    var popular = panel.querySelector('.popular-countries');
    if (popular) popular.classList.toggle('hidden', !!q);
    var reset = panel.querySelector('.country-filter__reset-button');
    if (reset) reset.classList.toggle('hidden', !q);
    var list = panel.querySelector('.country-selector__list');
    if (list) {
      list.scrollTop = 0;
      if (list.animate && !RM) list.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease' });
    }
    var live = panel.querySelector('#sr-country-search-results');
    if (live && window.accessibilityStrings && window.accessibilityStrings.countrySelectorSearchCount) {
      live.textContent = window.accessibilityStrings.countrySelectorSearchCount.replace('[count]', shown);
    }
    var empty = emptyLine(panel);
    if (empty) empty.classList.toggle('is-on', shown === 0);
    scheduleBlur();
  }

  function wireSearch() {
    var panel = countryPanel();
    if (!panel || panel.dataset.mxmSearch) return;
    var input = panel.querySelector('.country-filter__input');
    if (!input) return;
    panel.dataset.mxmSearch = '1';
    /* the theme's own keyup search finds nothing once the list has moved (and stops with an error) */
    panel.addEventListener('keyup', function (event) {
      if (event.target === input) event.stopPropagation();
    }, true);
    input.addEventListener('input', function () { filterList(panel, input.value); });
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var first = panel.querySelector('.countries .disclosure__item:not(.hidden) a');
      if (first) first.click();
    });
  }

  /* The theme's search also runs when the list closes or the reset X is tapped: there it now filters
     the moved list instead of stopping with an error (which left the page scroll lock on) */
  function patchSearch() {
    if (!window.customElements) return;
    customElements.whenDefined('localization-form').then(function () {
      var LF = customElements.get('localization-form');
      if (!LF || LF.prototype.__mxmSearch) return;
      var original = LF.prototype.filterCountries;
      LF.prototype.__mxmSearch = true;
      LF.prototype.filterCountries = function () {
        var panel = this.elements && this.elements.panel;
        if (panel && !this.contains(panel)) {
          filterList(panel, this.elements.search ? this.elements.search.value : '');
          return;
        }
        return original.apply(this, arguments);
      };
    });
  }

  /* 10. Country name and currency on the LOG IN row */
  function splitCountry() {
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('.menu-drawer__localization .disclosure__button > span').forEach(function (s) {
      if (s.querySelector('.mxm-cn')) return;
      var t = s.textContent.replace(/\s+/g, ' ').trim();
      var i = t.lastIndexOf(' | ');
      if (i < 1) return;
      var name = document.createElement('span');
      name.className = 'mxm-cn';
      name.textContent = t.slice(0, i);
      var cur = document.createElement('span');
      cur.className = 'mxm-cc';
      cur.textContent = ' | ' + t.slice(i + 3);
      s.textContent = '';
      s.appendChild(name);
      s.appendChild(cur);
    });
  }

  function init() { watchCountry(); watchDrawer(); addHandle(); wireSearch(); patchSearch(); splitCountry(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
